import { useQuery } from "@tanstack/react-query";

import { paymentsAPI } from "../paymentsAPI.ts";
import { queryClient } from "../../queryClient.ts";

const QUERY_KEY = "active-payment";

export const useCheckActivePaymentQuery = () => {
  return useQuery ({
    queryKey: [QUERY_KEY],
    queryFn: () => paymentsAPI.checkActivePayment(),
    select: (data) => {
      const time = data.isPaymentActive === false ? 15 * 60 * 1000 : 0; // 15мин или 0мин

      queryClient.setQueryDefaults([QUERY_KEY], {
        staleTime: time,
        gcTime: time,
      });

      return data;
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
